import IconButton from '@anm/components/buttons/IconButton';
import styled from 'styled-components';

export const WrappedAddIconButton = styled(IconButton)`
  max-width: 190px;
`;
